import * as ApiWithToken from "../callApiWithToken";

const EmblemsService = {
    getEmblems:async function(){
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `emblem/GetEmblemsByUser`);
    },
}

export default EmblemsService;